/** Monday 00:00:00.000 for the week containing `date` (UK week: Mon–Sun). */
export const getWeekStartMonday = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
};

/** True when `date` falls in the same calendar week (Mon–Sun) as `reference`. */
export const isSameCalendarWeek = (date, reference = new Date()) =>
  getWeekStartMonday(date).getTime() === getWeekStartMonday(reference).getTime();

/** Castle is open seven days a week. */
export const isCastleOpenAllDaysThisWeek = (_date = new Date()) => true;

/** Castle display copy for hero / opening-times cards. */
export const getCastleOpeningDisplay = (cmsCastle = {}, _referenceDate = new Date()) => {
  return {
    days: 'Mon - Sun',
    times: cmsCastle.times || '10:00 - 17:00',
    note: 'Open daily · Last entry 16:00',
  };
};

/** Whether Tue/Wed castle closure applies on this date — always false as castle is now open daily. */
export const isCastleClosedTuesdayOrWednesday = (_date) => false;

/** Animal Park is open seven days a week (Summer Safari season). */
export const isAnimalParkOpenAllDaysThisWeek = (_date = new Date()) => true;

/** Animal Park display copy for hero / info strips / page content. */
export const getAnimalParkOpeningDisplay = (_referenceDate = new Date()) => {
  if (isAnimalParkOpenAllDaysThisWeek(_referenceDate)) {
    return {
      days: 'Daily',
      times: '10:00 – 16:00',
      note: 'Open every day · Last entry 15:30',
    };
  }

  return {
    days: 'Sat – Sun',
    times: '10:00 – 16:00',
    note: 'Last entry 15:30',
  };
};
